import { render, staticRenderFns } from "./ClienteManage.vue?vue&type=template&id=597fa862"
import script from "./ClienteManage.vue?vue&type=script&lang=js"
export * from "./ClienteManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports